/**
 * @module Experience/repdash
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const CART_ITEM_STATUS = {
  ADD: 'ADD',
  RETAIN: 'RETAIN',
  REMOVE: 'REMOVE',
  ONDEMAND: 'ONDEMAND',
};

export const PLAN_SERVICES_CONSTANTS = {
  BACK: 'back',
  SUBMIT: 'submit',
  LINEDETAILS: 'lineDetails',
  MANAGE_PENDING_ORDERS: 'managePendingOrders',
  BUTTON_CLASS_PRIMARY: 'btn btn-primary',
  CANCELLED: 'CANCELLED',
  BUTTON_CLASS_SECONDARY: 'btn btn-secondary',
  RESUMECANCELLATION: '/resume-cancellation/select-line',
  CONTINUE: 'Continue',
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR'
};

export const ROUTER_CONSTANTS = {
  LINE_LANDING: '/line-landing',
  WARRANTY_EXCHANGE: '/warranty-exchange-summary',
  ACCOUNT_LANDING: '/account-landing',
};
